import { theme as apolloLightTheme } from 'material-ui-apollo';
import { mergeDeepLeft } from 'ramda';

import { appTheme } from './appTheme';

const lightTheme = mergeDeepLeft(appTheme, apolloLightTheme); //local theme overrides take precedence

export default lightTheme;



// WEBPACK FOOTER //
// ./src/Shared/Themes/lightTheme.js